import {
	AccountTypeEnum,
	AccountUpgradeApplicationSlugEnum,
	EmailTypeEnum,
	PhoneTypeEnum,
} from '.spec/self-care/tsTypes';
import { find, isObject, pipe, prop, propOr } from 'lodash/fp';

export const getName = (user, isEasternNamingOrder = false) => {
	const name = prop('name', user);

	if (!isObject(name)) {
		return '';
	}

	return isEasternNamingOrder
		? [name.lastName, name.firstName].filter(Boolean).join(' ')
		: [name.firstName, name.lastName].filter(Boolean).join(' ');
};

export const getPrimaryPhone = pipe(
	prop('phoneNumbers'),
	find({ phoneType: PhoneTypeEnum.PRIMARY })
);

export const getPrimaryEmail = pipe(prop('emails'), find({ type: EmailTypeEnum.PRIMARY_EMAIL }));

export const hasMaxiPackage = pipe(
	propOr(AccountTypeEnum.TRY_IT, 'accountType'),
	(accountType) => accountType === AccountTypeEnum.PLUS
);

export const hasValidKyc = (kyc) => Boolean(kyc) && !kyc.isOutdated && !kyc.isDocumentExpired;

/**
 * Computes if customer is blocked for revolving loan application - she has applied and was rejected and we don't want
 * her to re-apply again. The function assumes the user has OP_LIGHT account, using it for OP_FULL makes no sense.
 * @param {{ slug: string }} [myContractRevolvingApplication] - the result of MyContractRevolvingApplication or empty
 * 	when customer has no revolving-loan application yet.
 * @param {{ options: { canApplyForRevolvingContract: boolean } }} myProfile - the result of MyProfileQuery.
 * @return {boolean}
 */
export const hasBlockedRevLoan = ({ myContractRevolvingApplication, myProfile }) => {
	return (
		myProfile?.options.canApplyForRevolvingContract === false &&
		(!myContractRevolvingApplication ||
			[
				AccountUpgradeApplicationSlugEnum.CANCELLED,
				AccountUpgradeApplicationSlugEnum.DECLINED_GENERAL,
				AccountUpgradeApplicationSlugEnum.DECLINED_SCORING_REGISTERS,
			].includes(myContractRevolvingApplication.slug))
	);
};
